import TabsController from '@js/controllers/Tabs';

class ThirdParty extends TabsController {

}

export default ThirdParty;
